import { mapProject, Project } from "../Project/ProjectInterface";
import { mapCustomService, Service } from "../Project/Service/ServiceInterface";

export interface QuickAccessList {
    display_name?: string;
    projects?: QuickAccessProjects[];
}


// to single object maping
export const mapQuickAccessList = (data:any): QuickAccessList => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: QuickAccessList ={
        display_name: data.display_name,
        projects:mapQuickAccessProjectss(data.projects),
      
    }
    return res;
}

// maping list objects
export const mapQuickAccessLists = (data:any[]): QuickAccessList[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapQuickAccessList);
}




export interface QuickAccessProjects {
    folder_id?: number;
    project_id?: number;
    service_name?: string;
    folder_type?: string;
    address?: string;
    shared_by?: number | null;
    project_data?:Project,
    folder_data?:Service
}


// to single object maping
export const mapQuickAccessProjects = (data:any): QuickAccessProjects => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: QuickAccessProjects ={
        folder_id: data.folder_id,
        project_id: data.project_id,
        service_name: data.service_name,
        folder_type: data.folder_type,
        address: data.address,
        project_data:mapProject( data.project_data),
        folder_data: mapCustomService(data.folder_data),
        shared_by: data.shared_by,
      
    }
    return res;
}

// maping list objects
export const mapQuickAccessProjectss = (data:any[]): QuickAccessProjects[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapQuickAccessProjects);
}
